import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import EventForm from '../Form';
import { createEvent } from '@resources/Event/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createEvent, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createEvent(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.event.create',
						defaultMessage:
							'A new Event has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.event',
					defaultMessage: 'Create Event',
				})}
			</Title>
			<EventForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createEvent })(Create);
